// صفحة مهام مريم - التصميم والمنطق موحّدين بـ components/EmployeeTasksPage.jsx
import React from "react";
import EmployeeTasksPage from "./components/EmployeeTasksPage";

const MaryamTasks = () => (
  <EmployeeTasksPage employeeName="مريم" title="مريم" backPath="/maryam" />
);

export default MaryamTasks;
